export default __webpack_public_path__ + "static/media/alfredo3.f46fa7f3.png";